import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeValue } from '@angular/platform-browser';

@Pipe({
    name: 'flSafe',
    standalone: true,
    pure: true,
})
export class FlooriSafePipe implements PipeTransform {
    private securityMethods: Record<SafeResourceType, (value: string) => SafeValue> = {
        [SafeResourceType.html]: this.sanitizer.bypassSecurityTrustHtml,
        [SafeResourceType.resource]: this.sanitizer.bypassSecurityTrustResourceUrl,
        [SafeResourceType.style]: this.sanitizer.bypassSecurityTrustStyle,
        [SafeResourceType.script]: this.sanitizer.bypassSecurityTrustScript,
        [SafeResourceType.url]: this.sanitizer.bypassSecurityTrustUrl,
    };

    constructor(private sanitizer: DomSanitizer) {}

    transform(value: string, type: SafeResourceType = SafeResourceType.url): SafeValue {
        if (!value) {
            return '';
        }

        if (!this.securityMethods[type]) {
            return '';
        }

        return this.securityMethods[type](value);
    }
}

export enum SafeResourceType {
    html = 'html',
    resource = 'resource',
    style = 'style',
    script = 'script',
    url = 'url',
}
